/** Same App Store / Play links and badge art as `Confirmation.tsx` and the main app. */
export const APP_STORE_URL = 'https://apps.apple.com/app/meeteor/id6757962427';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.thspian.meeteor';
export const APP_STORE_BADGE_IMG = 'https://df41u66howm6r.cloudfront.net/app/app-store.png';
export const PLAY_STORE_BADGE_IMG = 'https://df41u66howm6r.cloudfront.net/app/g-store.png';
